import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/landing',
    pathMatch: 'full'
  },
  // {
  //   path: '',
  //   redirectTo: 'folder/Inbox',
  //   pathMatch: 'full'
  // },
  // {
  //   path: 'folder/:id',
  //   loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule)
  // },
  // {
  //   path: 'product-form',
  //   loadChildren: () => import('./pages/register-product/product-form/product-form.module').then( m => m.ProductFormPageModule)
  // },
  {
    path: 'product-tab-form',
    loadChildren: () => import('./pages/register-product/product-tab-form/product-tab-form.module').then(m => m.ProductTabFormPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'basic-requirement',
    loadChildren: () => import('./pages/register-product/basic-requirement/basic-requirement.module').then(m => m.BasicRequirementPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'consent',
    loadChildren: () => import('./pages/register-product/consent/consent.module').then(m => m.ConsentPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'applicant-contact-detail',
    loadChildren: () => import('./pages/register-product/applicant-contact-detail/applicant-contact-detail.module').then(m => m.ApplicantContactDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'applicant-emergency-contact',
    loadChildren: () => import('./pages/register-product/applicant-emergency-contact/applicant-emergency-contact.module').then(m => m.ApplicantEmergencyContactPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'applicant-employment-details',
    loadChildren: () => import('./pages/register-product/applicant-employment-details/applicant-employment-details.module').then(m => m.ApplicantEmploymentDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'applicant-financial-details',
    loadChildren: () => import('./pages/register-product/applicant-financial-details/applicant-financial-details.module').then(m => m.ApplicantFinancialDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'applicant-uploads',
    loadChildren: () => import('./pages/register-product/applicant-uploads/applicant-uploads.module').then(m => m.ApplicantUploadsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  // {
  //   path: 'home',
  //   loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
  //   canActivate: [AuthGuardService]
  // },
  {
    path: 'home-new',
    loadChildren: () => import('./pages/home-new/home-new.module').then(m => m.HomeNewPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'announcement-listing',
    loadChildren: () => import('./pages/announcement/announcement-listing/announcement-listing.module').then(m => m.AnnouncementListingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'announcement-details',
    loadChildren: () => import('./pages/announcement/announcement-details/announcement-details.module').then(m => m.AnnouncementDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'forget-password',
    loadChildren: () => import('./pages/user/forget-password/forget-password.module').then(m => m.ForgetPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/user/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/user/change-password/change-password.module').then(m => m.ChangePasswordPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'user-profile',
    loadChildren: () => import('./pages/user/user-profile/user-profile.module').then(m => m.UserProfilePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'application-listing',
    loadChildren: () => import('./pages/application/application-listing/application-listing.module').then(m => m.ApplicationListingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'application-detail',
    loadChildren: () => import('./pages/application/application-detail/application-detail.module').then(m => m.ApplicationDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'guarantor-personal-detail',
    loadChildren: () => import('./pages/guarantor-application/guarantor-personal-detail/guarantor-personal-detail.module').then(m => m.GuarantorPersonalDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'guarantor-employment-detail',
    loadChildren: () => import('./pages/guarantor-application/guarantor-employment-detail/guarantor-employment-detail.module').then(m => m.GuarantorEmploymentDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'guarantor-listing',
    loadChildren: () => import('./pages/guarantor-application/guarantor-listing/guarantor-listing.module').then(m => m.GuarantorListingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-listing',
    loadChildren: () => import('./pages/loan/loan-listing/loan-listing.module').then(m => m.LoanListingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-repayment',
    loadChildren: () => import('./pages/loan/loan-repayment/loan-repayment.module').then(m => m.LoanRepaymentPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-details',
    loadChildren: () => import('./pages/loan/loan-details/loan-details.module').then(m => m.LoanDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-transaction-details',
    loadChildren: () => import('./pages/loan/loan-transaction-details/loan-transaction-details.module').then(m => m.LoanTransactionDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-approve',
    loadChildren: () => import('./pages/draft-approval/draft-approval.module').then( m => m.DraftApprovalPageModule)
  },
  {
    path: 'onboarding-draft-listing',
    loadChildren: () => import('./pages/onboarding-draft-listing/onboarding-draft-listing.module').then( m => m.OnboardingDraftListingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'guarantor-financial-detail',
    loadChildren: () => import('./pages/guarantor-application/guarantor-financial-detail/guarantor-financial-detail.module').then( m => m.GuarantorFinancialDetailPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'upload-claims',
    loadChildren: () => import('./pages/upload-claims/upload-claims.module').then( m => m.UploadClaimsPageModule),
  },
  {
    path: 'auto-debit-registration',
    loadChildren: () => import('./pages/auto-debit-registration/auto-debit-registration.module').then( m => m.AutoDebitRegistrationPageModule)
  },
  {
    path: 'loan-application',
    loadChildren: () => import('./pages/loan-application/loan-application.module').then( m => m.LoanApplicationPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'eligibility-personal-details',
    loadChildren: () => import('./pages/eligibility-personal-details/eligibility-personal-details.module').then( m => m.EligibilityPersonalDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'eligibility-company-details',
    loadChildren: () => import('./pages/eligibility-company-details/eligibility-company-details.module').then( m => m.EligibilityCompanyDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'eligibility-loan-details',
    loadChildren: () => import('./pages/eligibility-loan-details/eligibility-loan-details.module').then( m => m.EligibilityLoanDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./pages/sign-up/sign-up.module').then(m => m.SignUpPageModule)
  },
  {
    path: 'otp',
    loadChildren: () => import('./pages/otp/otp.module').then( m => m.OtpPageModule)
  },
  {
    path: 'add-loan-details',
    loadChildren: () => import('./pages/additional-details/add-loan-details/add-loan-details.module').then( m => m.AddLoanDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/additional-details/terms/terms.module').then( m => m.TermsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'confirmation-message',
    loadChildren: () => import('./pages/additional-details/confirmation-message/confirmation-message.module').then( m => m.ConfirmationMessagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'consents',
    loadChildren: () => import('./pages/consents/consents.module').then( m => m.ConsentsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'site-visit',
    loadChildren: () => import('./pages/site-visit/site-visit.module').then( m => m.SiteVisitPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'app-loan-details',
    loadChildren: () => import('./pages/app-loan-details/app-loan-details.module').then( m => m.AppLoanDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'eligibility-result',
    loadChildren: () => import('./pages/eligibility-result/eligibility-result.module').then( m => m.EligibilityResultPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'upload-document',
    loadChildren: () => import('./pages/additional-details/upload-document/upload-document.module').then( m => m.UploadDocumentPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'add-doc-upload',
    loadChildren: () => import('./pages/add-doc-upload/add-doc-upload.module').then( m => m.AddDocUploadPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-additional-details',
    loadChildren: () => import('./pages/loan-additional-details/loan-additional-details.module').then( m => m.LoanAdditionalDetailsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'app-loan-additional',
    loadChildren: () => import('./pages/app-loan-additional/app-loan-additional.module').then( m => m.AppLoanAdditionalPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-repayment-schedule',
    loadChildren: () => import('./pages/loan-repayment-schedule/loan-repayment-schedule.module').then( m => m.LoanRepaymentSchedulePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'direct-debit-concent',
    loadChildren: () => import('./pages/direct-debit-concent/direct-debit-concent.module').then( m => m.DirectDebitConcentPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-repayment-history',
    loadChildren: () => import('./pages/loan-repayment-history/loan-repayment-history.module').then( m => m.LoanRepaymentHistoryPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'agreement-document',
    loadChildren: () => import('./pages/agreement-document/agreement-document.module').then( m => m.AgreementDocumentPageModule),
    canActivate: [AuthGuardService]

  },
  {
    path: 'location-yhs',
    loadChildren: () => import('./pages/location-yhs/location-yhs.module').then( m => m.LocationYhsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'ap-loan-detail-mobile',
    loadChildren: () => import('./pages/mobile/ap-loan-detail-mobile/ap-loan-detail-mobile.module').then( m => m.ApLoanDetailMobilePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'app-loan-adddetail-mobile',
    loadChildren: () => import('./pages/mobile/app-loan-adddetail-mobile/app-loan-adddetail-mobile.module').then( m => m.AppLoanAdddetailMobilePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'app-detail-company',
    loadChildren: () => import('./pages/mobile/app-detail-company/app-detail-company.module').then( m => m.AppDetailCompanyPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'app-detail-loan',
    loadChildren: () => import('./pages/mobile/app-detail-loan/app-detail-loan.module').then( m => m.AppDetailLoanPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-detail-tab',
    loadChildren: () => import('./pages/mobile/loan-detail-tab/loan-detail-tab.module').then( m => m.LoanDetailTabPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-detail-doc',
    loadChildren: () => import('./pages/mobile/loan-detail-doc/loan-detail-doc.module').then( m => m.LoanDetailDocPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'mobile-agreement',
    loadChildren: () => import('./pages/mobile/mobile-agreement/mobile-agreement.module').then( m => m.MobileAgreementPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'mobile-repayment-history',
    loadChildren: () => import('./pages/mobile/mobile-repayment-history/mobile-repayment-history.module').then( m => m.MobileRepaymentHistoryPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'mobile-repayment',
    loadChildren: () => import('./pages/mobile/mobile-repayment/mobile-repayment.module').then( m => m.MobileRepaymentPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'mobile-ekyc',
    loadChildren: () => import('./pages/mobile/mobile-ekyc/mobile-ekyc.module').then( m => m.MobileEkycPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'mobile-upload-adddoc',
    loadChildren: () => import('./pages/mobile/mobile-upload-adddoc/mobile-upload-adddoc.module').then( m => m.MobileUploadAdddocPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'logout',
    loadChildren: () => import('./pages/logout/logout.module').then( m => m.LogoutPageModule)
  },
  {
    path: 'auto-debit',
    loadChildren: () => import('./pages/auto-debit/auto-debit.module').then( m => m.AutoDebitPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'loan-calculator',
    loadChildren: () => import('./pages/loan-calculator/loan-calculator.module').then( m => m.LoanCalculatorPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./pages/maintenance/maintenance.module').then( m => m.MaintenancePageModule)
  },
  {
    path: 'loan-ekyc-submission',
    loadChildren: () => import('./pages/loan-ekyc-submission/loan-ekyc-submission.module').then( m => m.LoanEkycSubmissionPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'mobile-ekyc-submission',
    loadChildren: () => import('./pages/mobile/mobile-ekyc-submission/mobile-ekyc-submission.module').then( m => m.MobileEkycSubmissionPageModule),
    canActivate: [AuthGuardService]
  },
  // {
  //   path: 'home-new',
  //   loadChildren: () => import('./pages/home-new/home-new.module').then( m => m.HomeNewPageModule)
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
